// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pf5-","label":"styles_label__3EA5H"};